export default "__VITE_ASSET__6HYpS$oU__"